import '@babel/polyfill'
import Vue from 'vue'
import '@/plugins/vuetify'

import ECharts from 'vue-echarts'

import App from '@/App.vue'
import router from '@/router'

Vue.config.productionTip = false
Vue.component('v-chart', ECharts)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
router.replace('attribution')
